import React from 'react'

export const QuestionNumber = ({ number }) => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: '#004876',
    color: '#fff',
    fontSize: '0.8rem',
    fontWeight: 'bold',
    flexShrink: 0,
    marginRight: '1rem',
  }}>
    {number}
  </div>
)
